"use client";

import FaqPage from "@components/help/FaqPage";

export default FaqPage;
